// extracted by mini-css-extract-plugin
module.exports = {"add":"ProjectSettings_add__Q053x","add--highlight":"ProjectSettings_add--highlight__tZVb9"};